import script from "./BaseParallax.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseParallax.vue?vue&type=script&setup=true&lang=ts"

import "./BaseParallax.vue?vue&type=style&index=0&id=897227da&lang=scss"

const __exports__ = script;

export default __exports__